import React, { useState } from 'react';
import Table from 'components/Table';
import Popup from 'components/Popup';
import { Avatar, Breadcrumb } from 'xland-ui';
import { formatDate, getFullName } from 'utils/functions';
import { useSelector } from 'react-redux';
import { useCounter } from 'utils/customHooks';
import { Eye } from 'lucide-react';
import { fetchMessages } from '../modules/actions';

function Support() {
  const literals = useSelector(state => state.i18n.literals.admin.support);
  const [viewQuestion, setViewQuestion] = useState(null);
  const tableRefreshFlag = useCounter(0);

  const formatMessage = (message) => {
    let result = message;
    if (result.length >= 50) {
      result = result.slice(0, 47).concat('...');
    }
    return result;
  };

  const vieQuestionHandler = (event) => {
    setViewQuestion(event);
  };

  const columns = [
    {
      key: 'createdBy_avatar', field: 'createdBy', type: 'avatar', title: data => getFullName(data), preRender: data => data?.avatar,
    },
    {
      key: 'createdBy_firstname', field: 'createdBy', label: literals.firstname, grow: 1, preRender: data => data?.firstname,
    },
    {
      key: 'createdBy_lastname', field: 'createdBy', label: literals.lastname, grow: 2, preRender: data => data?.lastname,
    },
    {
      field: 'message', label: literals.message, grow: 3, preRender: message => formatMessage(message),
    },
    {
      field: 'createdAt', label: literals.date, width: 150, preRender: data => formatDate(data, { time: true }),
    },
    {
      field: 'Ver', type: 'button', button: { text: 'ver', icon: <Eye />, onClick: vieQuestionHandler },
    },
  ];

  return (
    <>
      <Breadcrumb routes={[{ name: literals.title }]} />
      <Table
        columns={columns}
        onClickRow={vieQuestionHandler}
        fetch={fetchMessages}
        forceFetch={tableRefreshFlag.value}
      />
      {viewQuestion && (
        <Popup
          title={literals.question}
          onClose={() => setViewQuestion(null)}
        >
          <div className='question'>
            <div className='question-header'>
              <div className='question-header-avatar'>
                <Avatar
                  title={getFullName(viewQuestion.createdBy)}
                  src={viewQuestion.createdBy?.avatar?.path}
                  size={50}
                />
              </div>
              <div className='question-header-name'>
                <p>{getFullName(viewQuestion.createdBy)}</p>
              </div>
            </div>
            <div className='question-body'>
              <h6>{literals.date}</h6>
              <p>{formatDate(viewQuestion.createdAt, { time: true })}</p>
              <h6>{literals.message}</h6>
              <p>{viewQuestion.message}</p>
            </div>
          </div>
        </Popup>
      )}
    </>
  );
}

export default Support;
